/** @jsx jsx */

import * as React from "react";
import {isEmpty as _isEmpty, map as _map, get as _get} from "lodash"
import { jsx } from "@emotion/core";
import { Tracker } from "../../../utils/Tracker";
import { EventNames } from "../../../utils/EventTrackerConstants";
import {rteSuggestion, rteSuggestionsContainer, rteWrapperStyle} from "./rteStyle";
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TypeAhead, {TypeAheadResults} from "../../TypeAhead";


interface RTEProps {
    name: string,
    value: string,
    onChange: (value: string) => void,
    suggestions: any[],
    updateSelectedSuggestions: (suggestion: string) => void,
    handleClick?: (data: {inputType: string, inputValue?: string | number, field?: string}) => void,
    onTypeAheadChange: (value: string) => Promise<TypeAheadResults>
}

let Link = Quill.import('formats/link');

class CustomLink extends Link {

    static sanitize(url: string) {
        let value = super.sanitize(url);
        if(value)
        {
            for(let i=0;i<CustomLink.PROTOCOL_WHITELIST.length;i++)
                if(value.startsWith(CustomLink.PROTOCOL_WHITELIST[i]))
                    return value;
            return `http://${value}`
        }
        return value;
    }
}
Quill.register(CustomLink);

const modules = {
    clipboard: {
        matchVisual: false // to disable insertion of empty paragraphs in between heading type text
    }
}

let Link = Quill.import('formats/link');

class CustomLink extends Link {

    static sanitize(url: string) {
        let value = super.sanitize(url);
        if(value)
        {
            for(let i=0;i<CustomLink.PROTOCOL_WHITELIST.length;i++)
                if(value.startsWith(CustomLink.PROTOCOL_WHITELIST[i]))
                    return value;
            return `http://${value}`
        }
        return value;
    }
}
Quill.register(CustomLink);

const RichText: React.SFC<RTEProps> = (props) => {
  let quillRef = React.useRef(null)
  const [noOfStrokes, setNoOfStrokes] = React.useState<number>(0);
  const [usedSuggestions, setUsedSuggestions] = React.useState<string[]>([])
  const [searchText, setSearchText] = React.useState<string>("")

  const handleChange = (value: string) => {
    props.onChange(value);
  }

  const onKeyDown = () => {
    setNoOfStrokes(noOfStrokes => noOfStrokes + 1);
  }

  const onBlur = () => {
    if (noOfStrokes) {
      Tracker.track(EventNames.KeyStroke, {
        field: props.name,
        noOfKeystrokes: noOfStrokes
      });
      setNoOfStrokes(0);
    }
  }

  const handleSuggestionClick = async (text: string, event: any, instrumentClick: boolean) => {
      event.stopPropagation()
      instrumentClick && props.handleClick({
          field: "Title",
          inputType: "Tags",
          inputValue: text
      })
      const editor = quillRef.current.getEditor()
      const updatedSuggestions = [...usedSuggestions, text]
      setUsedSuggestions(updatedSuggestions)
      props.updateSelectedSuggestions(text)
      await props.onChange(props.value + `<h2>${text}</h2>`)
      // TODO: figure out a way to handle cursor based text insertion
      // editor.focus()
      // const pos = editor.getSelection()
      // const index = pos && pos.index ? pos.index : 1
      // await editor.insertText(index, text, {"toolbar": {"header": 2}}, "user")
      editor.insertText(editor.getLength() + 1, " ", "bold", true)
      editor.insertText(editor.getLength() + 1, " ", "bold", true)
      editor.setSelection(editor.getLength() + 2, "user")
  }

  const findAndTriggerClickHandler = (element: HTMLElement) => {
      if (element && element.classList) {
          const {classList} = element
          if (classList.contains("ql-bold")) {
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Bold"
              })
              console.log("BOLD")
          } else if (classList.contains("ql-italic")) {
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Italic"
              })
              console.log("ITALIC")
          } else if (classList.contains("ql-underline")) {
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Underline"
              })
              console.log("UNDERLINE")
          } else if (classList.contains("ql-link")) {
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Hyperlink"
              })
              console.log("LINK")
          } else if (classList.contains("ql-list")) {
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Bold",
                  inputValue: _get(element, "value", null)
              })
              console.log("LIST", element.attributes)
          } else if (classList.contains("ql-clean")) {
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Clear formatting"
              })
              console.log("CLEAN")
          } else if (classList.contains("ql-picker")) {
              console.log("PICKER")
          } else if (classList.contains("ql-picker-item")) {
              const beforePseudoStyle = window.getComputedStyle(element, ":before")
              props.handleClick({
                  field: "Formatting Bar",
                  inputType: "Font style",
                  inputValue: beforePseudoStyle && beforePseudoStyle.getPropertyValue("content")
              })
              console.log("PICKER ITEM: ", element.dataset)
          }
      }
  }

  const handleClick = (event: any) => {
      const {target} = event
      const targetClass = _get(target, "classList", "")
      // handle SVG click
      if (targetClass.contains("ql-stroke") || targetClass.contains("ql-fill") || target.nodeName === "svg") {
          const wrapperBtn = _get(target, target.nodeName === "svg" ? "parentElement" : "parentElement.parentElement", null)
          findAndTriggerClickHandler(wrapperBtn)
          console.log({type: "SVG", parent: target.parentElement})
      } else {
          console.log({target})
          findAndTriggerClickHandler(target)
      }
  }

  const handleSuggestionSearch = (input: string) => {
      setSearchText(input)
      return props.onTypeAheadChange(input)
  }

  const handleTypeAheadSuggestionClick = (value: string, event: any) => {
      setSearchText("")
      handleSuggestionClick(value, event, false)
  }


  return (
    <div onKeyDown={onKeyDown} onBlur={onBlur} css={rteWrapperStyle} onClick={handleClick}>
        {!_isEmpty(props.suggestions) && <div css={rteSuggestionsContainer}>
            {
              _map(props.suggestions, (suggestion: any) => <span key={suggestion} css={rteSuggestion} onClick={(event: any) => handleSuggestionClick(suggestion, event, true)}>{suggestion}</span>)
            }
            <TypeAhead
                name={""}
                value={searchText}
                placeholder={"Other"}
                onTypeAheadChange={handleSuggestionSearch}
                onClickHandler={(event, data) => props.handleClick(data)}
                onTypeAheadSelect={(elem, idx, noOfKeyStrokes, event) => handleTypeAheadSuggestionClick(elem.label, event)}
            />
        </div>}
        <ReactQuill ref={ref => quillRef.current = ref} theme="snow" value={props.value} onChange={handleChange} modules={modules} />
    </div>
  )
}

export default RichText;